import styled from 'styled-components';
import Card from 'react-bootstrap/Card';
import Table from 'react-bootstrap/Table';

export const Section = styled.div`
	margin-bottom: 16px;
`;

export const SectionTitle = styled.div`
	font-size: 0.85rem;
	color: var(--bs-secondary);
	margin-bottom: 8px;
	font-weight: 600;
`;

export const MatrixTableWrapper = styled.div`
	overflow-x: auto;
	max-width: 100%;
`;

export const MatrixTable = styled(Table)`
	font-size: 0.8rem;
	background: var(--bs-body-bg);
	min-width: max-content;

	th,
	td {
		padding: 6px 8px;
		text-align: center;
		vertical-align: middle;
		white-space: nowrap;
	}

	th {
		font-size: 0.75rem;
	}

	input {
		width: 60px;
		padding: 4px;
		text-align: center;
		background: transparent;
		border: 1px solid var(--bs-border-color);
		border-radius: 4px;
		color: var(--bs-body-color);
		font-size: 0.8rem;

		&:focus {
			outline: none;
			border-color: var(--bs-primary);
		}
	}
`;

export const ClassItem = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 8px 12px;
	background: var(--bs-body-bg);
	border-radius: 6px;
	margin-bottom: 8px;
`;

export const ColorInput = styled.input`
	width: 24px;
	height: 24px;
	padding: 0;
	border: 2px solid var(--bs-border-color);
	border-radius: 4px;
	cursor: pointer;
	flex-shrink: 0;

	&::-webkit-color-swatch-wrapper {
		padding: 1px;
	}
	&::-webkit-color-swatch {
		border-radius: 3px;
		border: none;
	}
`;

export const BandTag = styled.div`
	display: inline-flex;
	align-items: center;
	gap: 4px;
	padding: 4px 8px;
	background: var(--bs-body-bg);
	border-radius: 6px;
	margin: 4px;

	input {
		width: 50px;
		background: transparent;
		border: 1px solid var(--bs-border-color);
		border-radius: 4px;
		text-align: center;
		color: var(--bs-body-color);
		padding: 4px 6px;
		font-weight: 500;
		font-size: 0.85rem;

		&:focus {
			outline: none;
			border-color: var(--bs-primary);
		}
	}

	button {
		background: none;
		border: none;
		color: var(--bs-danger);
		cursor: pointer;
		padding: 0 4px;
		opacity: 0.6;

		&:hover {
			opacity: 1;
		}
	}
`;

export const StatsTable = styled(Table)`
	font-size: 0.85rem;

	th,
	td {
		padding: 8px 10px;
		vertical-align: middle;
	}
`;

export const ColorDot = styled.span`
	display: inline-block;
	width: 14px;
	height: 14px;
	border-radius: 3px;
	margin-right: 8px;
	background: ${props => props.color};
`;

export const EditorGrid = styled.div`
	display: grid;
	grid-template-columns: 1fr 1.7fr 0.8fr;
	gap: 24px;

	@media (max-width: 1200px) {
		grid-template-columns: 1fr 1fr;
	}

	@media (max-width: 768px) {
		grid-template-columns: 1fr;
	}
`;

export const SimpleClassCardsGrid = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 12px;
`;

export const EditorColumn = styled.div``;

export const SummaryCard = styled(Card)`
	background: var(--bs-dark);
	border: 1px solid var(--bs-border-color);
`;

export const SummaryRow = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 8px 0;
	border-bottom: 1px solid var(--bs-border-color);
	font-size: 0.85rem;

	&:last-child {
		border-bottom: none;
	}
`;

export const SummaryLabel = styled.span`
	display: flex;
	align-items: center;
	gap: 8px;
`;

export const SummaryValue = styled.span`
	font-weight: 600;
	text-align: right;
`;

export const TotalRow = styled(SummaryRow)`
	background: var(--bs-primary);
	margin: 0 -12px -12px;
	padding: 12px;
	border-radius: 0 0 6px 6px;
	font-weight: 700;
	font-size: 1.1rem;
`;

export const SimpleClassCard = styled.div`
	background: var(--bs-body-bg);
	border: 1px solid var(--bs-border-color);
	border-radius: 8px;
	padding: 12px;
	width: 280px;
	min-width: 240px;
	flex-shrink: 0;
	position: relative;
`;

export const SimpleClassHeader = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	margin-bottom: 10px;
	flex-wrap: wrap;

	& > span.text-muted {
		width: 100%;
		font-size: 0.75rem;
		margin-top: -4px;
	}
`;

export const RangeSliderContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	margin-top: 8px;
`;

export const RangeSlider = styled.input`
	flex: 1;
	height: 6px;
	-webkit-appearance: none;
	background: ${props => props.$color || 'var(--bs-secondary)'};
	border-radius: 3px;
	opacity: 0.7;

	&::-webkit-slider-thumb {
		-webkit-appearance: none;
		width: 16px;
		height: 16px;
		border-radius: 50%;
		background: ${props => props.$color || 'var(--bs-primary)'};
		cursor: pointer;
		border: 2px solid white;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
	}

	&::-moz-range-thumb {
		width: 16px;
		height: 16px;
		border-radius: 50%;
		background: ${props => props.$color || 'var(--bs-primary)'};
		cursor: pointer;
		border: 2px solid white;
	}
`;

export const PriceInput = styled.input`
	width: 70px;
	padding: 4px 6px;
	text-align: right;
	background: transparent;
	border: 1px solid var(--bs-border-color);
	border-radius: 4px;
	color: var(--bs-body-color);
	font-size: 0.85rem;

	&:focus {
		outline: none;
		border-color: var(--bs-primary);
	}
`;

export const SummaryDetailText = styled.span`
	display: block;
	font-size: 0.7rem;
	color: var(--bs-secondary);
	font-weight: 400;
	margin-top: 2px;
`;

export const EditableLabelInput = styled.input`
	background: transparent;
	border: none;
	border-bottom: 1px dashed var(--bs-border-color);
	color: var(--bs-body-color);
	font-size: 0.8rem;
	padding: 0 2px;
	width: 100%;
	max-width: 140px;

	&:focus {
		outline: none;
		border-bottom-color: var(--bs-primary);
	}
`;

export const TotalAreaRow = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 6px 0;
	font-size: 0.8rem;
	color: var(--bs-secondary);
	border-bottom: 1px solid var(--bs-border-color);
`;
